import {useEffect, useState} from "react";
import {collection, getCountFromServer, getDocs, limit, orderBy, query, startAfter} from "firebase/firestore";
import {fire} from "../../fire";

export const useObtenerColWhereProg = ({coleccion, wheres, numero = 10, orden = 'fecha', direccion = 'asc'}) => {
    const [data, setData] = useState([])
    const [ultimo, setUltimo] = useState(null)
    const [numTotal, setNumTotal] = useState(0)
    const [cargando, setCargando] = useState(false)

    const cargarMas = () => {
        obtenerData({wheres_: wheres, orden_: orden, direccion_: direccion, ultimo_: ultimo}).then()
    }

    const obtenerNumTotal = async () => {
        let q = query(collection(fire, coleccion),
            ...wheres);

        let dox = await getCountFromServer(q)
        if (dox.data()) {
            setNumTotal(dox.data().count)
        } else {
            setNumTotal(0)
        }

    }

    const obtenerData = async ({wheres_, orden_, direccion_, ultimo_ = null}) => {

        setCargando(true);

        let q
        let arr = []

        if (ultimo_) {
            arr = [...data]
            q = query(collection(fire, coleccion),
                ...wheres_,
                orderBy(orden_, direccion_), limit(numero), startAfter(ultimo_))

        } else {

            q = query(collection(fire, coleccion),
                ...wheres_,
                orderBy(orden_, direccion_), limit(numero))
        }

        let snap = await getDocs(q)
        //  console.log(wheres.toString(),snap)

        let i = 0


        snap.forEach((doc) => {
            arr.push(doc.data())
            if (i === snap.size - 1) {
                setUltimo(doc)
            }
            i++
        })


        setData(arr)
        setCargando(false);

    }

    useEffect(() => {


        obtenerData({wheres_: wheres, orden_: orden, direccion_: direccion}).then()
        obtenerNumTotal().then()


    }, [wheres, orden, direccion]);
    return {
        numData: data.length,
        data,
        cargarMas,
        numTotal,
        setData,
        cargando
    }
}